import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { ExtraGuestTypeLabel } from './AccommodationAmenitiesAndPoliciesContent'
import LineBedIcon from 'LuxKit/Icons/line/LineBedIcon'
import getPropertyIcon from 'lib/offer/getPropertyIcon'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import type { ExtraGuestGeneratedPolicies } from './AccommodationAmenitiesAndPoliciesContent'

const ACCOMMODATION_INCLUSION_ICON_SIZE = 'S'

type Props = {
  beddingDetails: string
  extraGuestGeneratedPolicies: ExtraGuestGeneratedPolicies
}

function resolveIcon(iconName: string | undefined) {
  if (!iconName) return undefined
  if (iconName.startsWith('line_') || iconName.startsWith('solid_')) {
    return getPropertyIcon(iconName as App.Property.IconName)
  }
  return getOfferFeatureIcon(iconName as App.OfferFeatureSymbol)
}

const normalizeGuestTypeLabel = (guestTypeLabel: string) => {
  return guestTypeLabel.toLowerCase()
}

const getExtraBeddingByGuestType = (
  extraGuestGeneratedPolicies: ExtraGuestGeneratedPolicies,
  guestTypeLabel: ExtraGuestTypeLabel,
) => {
  return extraGuestGeneratedPolicies.extraGuestGeneratedPolicyItems.find((item) => {
    return normalizeGuestTypeLabel(item.guest_type_label) === guestTypeLabel
  })?.extra_bedding
}

function AccommodationBeddingDetails({ beddingDetails, extraGuestGeneratedPolicies }: Props) {
  const intl = useIntl()

  const heading = intl.formatMessage({
    id: 'a7p4UZQg5x2c8aPHqF_N',
    defaultMessage: 'Bedding',
    description: 'Heading for the bedding configuration section within the guest policy area of the room details modal.',
  })

  const childrenExtraBedding = getExtraBeddingByGuestType(extraGuestGeneratedPolicies, ExtraGuestTypeLabel.Children)
  const infantsExtraBedding = getExtraBeddingByGuestType(extraGuestGeneratedPolicies, ExtraGuestTypeLabel.Infants)
  const iconBeddingItems = extraGuestGeneratedPolicies.beddingConfigurationExtras

  return (
    <>
      <BodyText variant="medium" weight="bold" as="h4">{heading}</BodyText>
      <BodyTextBlock variant="medium" startIcon={<LineBedIcon aria-hidden="true" size={ACCOMMODATION_INCLUSION_ICON_SIZE} />}>{beddingDetails}</BodyTextBlock>
      {[childrenExtraBedding, infantsExtraBedding].filter(Boolean).map((item) => (
        <BodyText key={item} variant="medium">{item}</BodyText>
      ))}
      {iconBeddingItems.map((item) => {
        const Icon = resolveIcon(item.icon)
        return Icon
          ? <BodyTextBlock key={item.text} variant="medium" startIcon={<Icon aria-hidden="true" size={ACCOMMODATION_INCLUSION_ICON_SIZE} />}>{item.text}</BodyTextBlock>
          : <BodyText key={item.text} variant="medium">{item.text}</BodyText>
      })}
    </>
  )
}

export default AccommodationBeddingDetails
